// COPIA DICHIARATA di src/lib/scopa/ticket.ts @ e99b95115c26c5085335a527db6cb22b23fd2f81 (TMA#735, 2026-10-20)
// Il TICKET del socket del tavolo: la forma del corpo e della risposta del BFF di Limulo (`POST /v1/games/<dominio>/session-ticket`). Funzioni PURE, niente rete: la
// mutation sta nel servizio del gioco, che la inietta in `limuloApi`.
// Cosa cambia rispetto alla fonte: il gioco e il `dominio` della rotta (parametro di `ticketRoute`), e i nomi perdono il prefisso del gioco
// (`ticketRoute`, `tavoloIdValido`, `ticketBody`, `ticketGrantOf`, `TicketGrant`). Il corpo, il validatore dell'uuid e la lettura della risposta sono IDENTICI.
//
// Il corpo e `{ tableId }` (uuid canonico MINUSCOLO: altrimenti 400 `INVALID_TABLE_ID`) e lo scopo del ticket lo compone la rotta del kit, UNO solo
// (`table:<tableId>`, ADR-0124 §4): un `purpose` mandato da qui non arriva a nessuno. La rotta del core risponde `{ ticket, expiresInSeconds, wsUrl }`.
//
// Il ticket e MONOUSO e dura 30 s: chi lo chiede lo chiede a OGNI connessione (socket.ts), mai da una cache, mai salvato.

/** La rotta del BFF per il gioco `dominio`. Una POST: non si ritenta mai da sola (un nuovo tentativo e un ticket NUOVO, ADR-0124 §4). */
export const ticketRoute = (dominio: string): string => `/v1/games/${dominio}/session-ticket`;

/** L'`id` della rotta del tavolo e l'uuid del tavolo del game host: altro non apre nessun socket. */
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const tavoloIdValido = (id: string | null | undefined): id is string => typeof id === 'string' && UUID.test(id);

/**
 * Il corpo della richiesta: SOLO il `tableId`, minuscolo. ⛔ Niente `purpose`: lo scopo (`table:<id>`, gli spettatori non esistono: informazione nascosta)
 * lo compone la rotta del kit.
 */
export const ticketBody = (tableId: string): { tableId: string } => ({ tableId: tableId.toLowerCase() });

export interface TicketGrant {
  ticket: string;
  wsUrl: string;
}

const asRecord = (v: unknown): Record<string, unknown> => (v !== null && typeof v === 'object' && !Array.isArray(v) ? (v as Record<string, unknown>) : {});
const testo = (v: unknown): string | null => (typeof v === 'string' && v.trim() !== '' ? v.trim() : null);

/**
 * Il ticket dal `data` del BFF. Un ticket senza indirizzo, o un indirizzo senza ticket, e `null`: un indirizzo vuoto non e un indirizzo. L'indirizzo e QUELLO della
 * risposta: nessun host scritto qui e nessuna `VITE_*` per il game host.
 */
export function ticketGrantOf(data: unknown): TicketGrant | null {
  const r = asRecord(data);
  const ticket = testo(r.ticket);
  const wsUrl = testo(r.wsUrl);
  return ticket !== null && wsUrl !== null ? { ticket, wsUrl } : null;
}
